<template>
  <div class="article-cases" v-if="cases && cases.length >0 ">
    <div class="article-item" v-for="item in cases" :key="item.id" @click="onArticleClick(item.id)">
      <el-image fit="cover" :src="item.onlShowUrl" />
      <div class="title">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cases: Array
  },
  methods: {
    onArticleClick(id) {
      this.$router.push({
        path: '/articleDetail',
        query: {
          articleId: id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.article-cases {
  display: grid;
  margin-top: 16px;
  margin-left: 10px;
  margin-right: 10px;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 260px;
  grid-gap: 16px;
  padding-bottom: 32px;
  .article-item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-top: 16px;
      color: #595757;
      font-size: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .el-image {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/articleCase.vue